import type { ReactNode } from "react";

/** Synced → emerald, needs a look → amber, unbilled or failing → rose, neutral → grey. */
export type Tone = "synced" | "discrepancy" | "unbilled" | "neutral";

const TONE_CLASS: Record<Tone, string> = {
  synced: "green",
  discrepancy: "yellow",
  unbilled: "red",
  neutral: "neutral",
};

export function StatusBadge({ tone, children, title }: { tone: Tone; children: ReactNode; title?: string }) {
  return (
    <span className={`badge ${TONE_CLASS[tone]}`} title={title}>
      {children}
    </span>
  );
}
